<template>
  <div v-if="show" :class="['cp-gpay-pop', classStyle]">
    <p v-if="typeStyle === 'xx'" class="cp-gpay-pop_xx-title"></p>
    <i class="cp-gpay-close" @click="close" />
    <div class="cp-gpay-iframe"><iframe :src="gpayUrl"></iframe></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      gpayUrl: '',
      classStyle: {
        'cp-gpay-pop_default-cq': false,
        'cp-gpay-pop_default-xx': false,
        'cp-gpay-pop_optional-cq': false,
        'cp-gpay-pop_optional-xx': false
      },
      typeStyle: ''
    }
  },
  mounted() {
    this.onMessage()
  },
  methods: {
    close() {
      this.show = false
    },
    onMessage() {
      window.addEventListener(
        'message',
        (e) => {
          if (typeof e.data === 'object' && e.data.rule === 'h5game') {
            const { data, event } = e.data
            if (event === 'placeOrder') {
              // 支付
              console.log('支付参数:', data)
              const game_id = this.$route.params.game_id
              const {
                game_code,
                server_num,
                roleid = '',
                rolename = '',
                uid,
                money,
                product_id,
                product_name,
                rechargeType,
                rechargeStyle,
                extra
              } = data
              const classObj = {
                'cp-gpay-pop_default-cq': false,
                'cp-gpay-pop_default-xx': false,
                'cp-gpay-pop_optional-cq': false,
                'cp-gpay-pop_optional-xx': false
              }
              classObj[`cp-gpay-pop_${rechargeType}-${rechargeStyle}`] = true
              this.classStyle = classObj
              this.typeStyle = rechargeStyle
              this.gpayUrl = `https://wan.xunlei.com/gpay/index.html?game_code=${game_code}&game_role_name=${encodeURIComponent(
                rolename
              )}&game_id=${game_id}&rechargeType=${rechargeType}&uid=${uid}&server_num=${server_num}&money=${money}&product_id=${product_id}&product_name=${encodeURIComponent(
                product_name
              )}&game_role_id=${roleid}&rechargeStyle=${rechargeStyle}&extra=${extra}`
              const succfn = () => {
                this.show = true
              }
              this.$util.realNameAuth('pay', 'default', succfn)
            }
          }
        },
        false
      )
    }
  }
}
</script>

<style lang="scss">
.cp-gpay-pop {
  z-index: 999999;
  position: fixed;
  left: 50%;
  top: 50%;
  box-sizing: border-box;

  &_default-cq {
    width: 366px;
    height: 393px;
    margin-top: -196.5px;
    margin-left: -183px;
    background: url(~assets/img/recharge/cq_bg.png) no-repeat;

    .cp-gpay-close {
      top: 8px;
      right: 9px;
      width: 32px;
      height: 32px;
      background: url(~assets/img/recharge/cq_btn_close.png) no-repeat;
    }

    .cp-gpay-iframe {
      width: 344px;
      height: 329px;
      margin-top: 54px;
      margin-left: 11px;
    }
  }

  &_default-xx {
    width: 378px;
    height: 368px;
    margin-top: -184px;
    margin-left: -189px;

    .cp-gpay-pop_xx-title {
      position: absolute;
      top: 5px;
      left: 0;
      width: 378px;
      height: 46px;
      background: url(~assets/img/recharge/xx_bg_title.png) no-repeat;

      &::before,
      &::after {
        position: absolute;
        top: 46px;
        content: '';
        width: 26px;
        height: 94px;
      }

      &::before {
        left: 12px;
        background: url(~assets/img/recharge/xx_bg_left.png) no-repeat;
      }

      &::after {
        right: 12px;
        background: url(~assets/img/recharge/xx_bg_right.png) no-repeat;
      }
    }

    .cp-gpay-close {
      z-index: 1;
      top: 8px;
      right: 9px;
      width: 35px;
      height: 45px;
      background: url(~assets/img/recharge/xx_btn_close.png) no-repeat;
    }

    .cp-gpay-iframe {
      width: 344px;
      height: 329px;
      margin-top: 39px;
      margin-left: 17px;
      background-color: #f0dfc3;
    }
  }

  &_optional-cq {
    width: 575px;
    height: 381px;
    margin-top: -190.5px;
    margin-left: -287.5px;
    background: url(~assets/img/recharge/cq_optional_bg.png) no-repeat;

    .cp-gpay-close {
      top: 8px;
      right: 9px;
      width: 32px;
      height: 32px;
      background: url(~assets/img/recharge/cq_btn_close.png) no-repeat;
    }

    .cp-gpay-iframe {
      width: 550px;
      height: 316px;
      margin-top: 54px;
      margin-left: 11px;
    }
  }

  &_optional-xx {
    width: 595px;
    height: 357px;
    margin-top: -178.5px;
    margin-left: -297.5px;

    .cp-gpay-pop_xx-title {
      position: absolute;
      top: 5px;
      left: 0;
      width: 595px;
      height: 46px;
      background: url(~assets/img/recharge/xx_optional_bg_title.png) no-repeat;

      &::before,
      &::after {
        position: absolute;
        top: 46px;
        content: '';
        width: 26px;
        height: 94px;
      }

      &::before {
        left: 12px;
        background: url(~assets/img/recharge/xx_bg_left.png) no-repeat;
      }

      &::after {
        right: 12px;
        background: url(~assets/img/recharge/xx_bg_right.png) no-repeat;
      }
    }

    .cp-gpay-close {
      z-index: 1;
      top: 8px;
      right: 42px;
      width: 35px;
      height: 45px;
      background: url(~assets/img/recharge/xx_btn_close.png) no-repeat;
    }

    .cp-gpay-iframe {
      width: 550px;
      height: 316px;
      margin-top: 39px;
      margin-left: 22.5px;
      background-color: #f0dfc3;
    }
  }

  .cp-gpay-close {
    position: absolute;
    cursor: pointer;
  }
}
</style>
